export const bodyPartsData = {
  frontHead: [
    { id: "forehead", name: "Forehead", coords: [155, 45, 15], side: "front" },
    { id: "eyes", name: "Eyes", coords: [165, 65, 12], side: "front" },
    { id: "nose", name: "Nose", coords: [150, 85, 8], side: "front" },
    { id: "mouth", name: "Mouth", coords: [150, 95, 8], side: "front" },
    { id: "chin", name: "Chin", coords: [151, 108, 8], side: "front" },
    { id: "left-ear", name: "Left Ear", coords: [185, 79, 8], side: "front" },
    { id: "right-ear", name: "Right Ear", coords: [120, 78, 8], side: "front" },
  ],
  neckShoulders: [
    { id: "neck", name: "Neck", coords: [150, 120, 15], side: "front" },
    { id: "left-shoulder", name: "Left Shoulder", coords: [220, 150, 15], side: "front" },
    { id: "right-shoulder", name: "Right Shoulder", coords: [80, 150, 15], side: "front" },
  ],

  // Arms - front
  armsFront: [
    { id: "left-upper-arm", name: "Left Upper Arm", coords: [220, 180, 15], side: "front" },
    { id: "right-upper-arm", name: "Right Upper Arm", coords: [80, 180, 15], side: "front" },
    { id: "left-elbow", name: "Left Elbow", coords: [229, 229, 12], side: "front" },
    { id: "right-elbow", name: "Right Elbow", coords: [75, 229, 12], side: "front" },
    { id: "left-forearm", name: "Left Forearm", coords: [229, 270, 15], side: "front" },
    { id: "right-forearm", name: "Right Forearm", coords: [71, 270, 15], side: "front" },
    { id: "left-wrist", name: "Left Wrist", coords: [237, 295, 10], side: "front" },
    { id: "right-wrist", name: "Right Wrist", coords: [67, 295, 10], side: "front" },
    { id: "left-hand", name: "Left Hand", coords: [250, 320, 12], side: "front" },
    { id: "right-hand", name: "Right Hand", coords: [60, 320, 12], side: "front" },
    { id: "left-fingers", name: "Left Fingers", coords: [240, 350, 10], side: "front" },
    { id: "right-fingers", name: "Right Fingers", coords: [60, 350, 10], side: "front" },
  ],

  // Torso - front
  torsoFront: [
    { id: "chest", name: "Chest", coords: [155, 180, 30], side: "front" },
    { id: "abdomen", name: "Abdomen", coords: [155, 250, 30], side: "front" },
    { id: "hips", name: "Hips", coords: [185, 280, 20], side: "front" },
    { id: "hips", name: "Hips", coords: [115, 280, 20], side: "front" },
  ],

  // Legs - front
  legsFront: [
    { id: "left-thigh", name: "Left Thigh", coords: [180, 350, 20], side: "front" },
    { id: "right-thigh", name: "Right Thigh", coords: [117, 350, 20], side: "front" },
    { id: "left-knee", name: "Left Knee", coords: [180, 425, 15], side: "front" },
    { id: "right-knee", name: "Right Knee", coords: [120, 425, 15], side: "front" },
    { id: "left-shin", name: "Left Shin", coords: [180, 470, 15], side: "front" },
    { id: "right-shin", name: "Right Shin", coords: [128, 470, 15], side: "front" },
    { id: "left-ankle", name: "Left Ankle", coords: [180, 550, 10], side: "front" },
    { id: "right-ankle", name: "Right Ankle", coords: [120, 550, 10], side: "front" },
    { id: "left-foot", name: "Left Foot", coords: [150, 490, 12], side: "front" },
    { id: "right-foot", name: "Right Foot", coords: [220, 490, 12], side: "front" },
    { id: "left-toes", name: "Left Toes", coords: [220, 585, 8], side: "front" },
    { id: "right-toes", name: "Right Toes", coords: [80, 585, 8], side: "front" },
  ],

  // Back view
  backView: [
    { id: "back-head", name: "Back of Head", coords: [395, 50, 20], side: "back" },
    { id: "upper-back", name: "Upper Back", coords: [395, 170, 30], side: "back" },
    { id: "lower-back", name: "Lower Back", coords: [395, 240, 30], side: "back" },
    { id: "left-shoulder-back", name: "Left Shoulder", coords: [325, 150, 15], side: "back" },
    { id: "right-shoulder-back", name: "Right Shoulder", coords: [460, 150, 15], side: "back" },
  ],

  // Arms - back
  armsBack: [
    { id: "left-upper-arm-back", name: "Left Upper Arm", coords: [325, 198, 15, "back"], side: "back" },
    { id: "right-upper-arm-back", name: "Right Upper Arm", coords: [460, 195, 15], side: "back" },
    { id: "left-elbow-back", name: "Left Elbow", coords: [320, 230, 12], side: "back" },
    { id: "right-elbow-back", name: "Right Elbow", coords: [460, 230, 12], side: "back" },
    { id: "left-forearm-back", name: "Left Forearm", coords: [320, 270, 15], side: "back" },
    { id: "right-forearm-back", name: "Right Forearm", coords: [470, 270, 15], side: "back" },
  ],

  // Legs - back
  legsBack: [
    { id: "left-thigh-back", name: "Left Thigh", coords: [370, 390, 20], side: "back" },
    { id: "right-thigh-back", name: "Right Thigh", coords: [420, 390, 20], side: "back" },
    { id: "left-knee-back", name: "Left Knee", coords: [370, 430, 15], side: "back" },
    { id: "right-knee-back", name: "Right Knee", coords: [420, 430, 15], side: "back" },
    { id: "left-calf", name: "Left Calf", coords: [370, 470, 15], side: "back" },
    { id: "right-calf", name: "Right Calf", coords: [420, 470, 15], side: "back" },
  ],
};

export const getAllBodyParts = () => Object.values(bodyPartsData).flat();

export const getBodyPartsByRegion = (region) => bodyPartsData[region] || [];

export const getBodyPartById = (id) => getAllBodyParts().find((part) => part.id === id);
